
export default {
  name: 'PreApplicationQuestions',

  props: {
    modalOpen: Boolean,
    projectData: {
      type: Object,
      required: true
    },
    createPasswordPage: Boolean
  },

  data() {
    return {
      userAnswers: [],
      answersFailed: false
    }
  },

  computed: {
    dialog: {
      get() {
        return this.modalOpen
      },
      set(value) {
        this.$emit('update:modal-open', value)
      }
    },

    submissionButtonText() {
      return this.answersFailed && !this.createPasswordPage
        ? this.$t('talent.global.project.return.search')
        : this.$t('talent.global.project.proceed')
    }
  },

  watch: {
    projectData: {
      immediate: true,
      deep: true,
      handler(obj) {
        if (obj && obj.preApplicationQuestions) {
          const knockOutValues = obj.preApplicationQuestions
          this.userAnswers = knockOutValues.map((el, i) => {
            return { item: i, value: null }
          })
        }
      }
    }
  },

  methods: {
    checkPreApplicationQuestions() {
      const checkForNulls = this.userAnswers.filter((el) => el.value === null)
      const pushGtmEvent = (result) =>
        this.$pushEvent('preApplicationQuestionsResult', {
          talentId: this.$auth.user?.id ?? null,
          result
        })
      let result = false

      if (checkForNulls.length) {
        // prettier-ignore
        this.$toast.fire(
          this.$t('talent.global.project.warning.provide.answers'),
          { type: 'error' }
        )
      } else if (!this.answersFailed) {
        for (let i = 0; i < this.userAnswers.length; i++) {
          if (this.userAnswers[i].value !== true) {
            this.$emit('on-answers', 'fail')
            this.answersFailed = true

            pushGtmEvent(result)

            return
          }
        }
        this.$emit('on-answers', 'success')
        result = true
      } else {
        this.$emit('on-answers', 'fail-proceed')
      }

      pushGtmEvent(result)
    }
  }
}
